import { createTable, Link as LinkMagik, Pagination } from "@inmagik/magik-ui"
import { FiltersBase, Citta } from "../../types"
import { Link } from "react-router-dom"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"

const Table = createTable<Citta>()

export function TableCitta({
  citta,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  citta: Citta[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  const numPages = useMemo(() => {
    if (!citta) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [citta, count])

  return (
    <Table
      data={citta}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Column
        title="Nome"
        name="nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(citta) => (
          <Link to={`/citta/citta/${citta.id}`}>
            <LinkMagik className="text-dark">{citta.nome}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />

      <Table.Column
        title="Latitudine"
        name="latitudine"
        sortable
        width="minmax(max-content, 1fr)"
        render={(citta) => <span>{citta.lat}</span>}
      />

      <Table.Column
        title="Longitudine"
        name="longitudine"
        sortable
        width="minmax(max-content, 1fr)"
        render={(citta) => <span>{citta.lon}</span>}
      />  

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} città
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
